"use client";
// Imports
import { Icon } from "@/components";
import { formatShowCalendarDayLabel } from "@/lib/showDates";

export function EventTimes({
  collectionHandle,
  eventTimes,
  everyDay,
  selectedDay,
  hideTimesOnCard = false,
}) {
  if (collectionHandle !== "events") return null;

  function getAllDatesString(eventTimes) {
    let dates = [];

    eventTimes.map((eventTime) => {
      const dateString = formatShowCalendarDayLabel(eventTime?.date);
      if (dateString && !dates.includes(dateString)) {
        dates.push(dateString);
      }
    });

    // Sorting dates based on the actual Adelaide calendar day
    dates.sort((a, b) => {
      const [dayA, monthA] = a.split(" ");
      const [dayB, monthB] = b.split(" ");

      const monthMap = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };

      const dateA = new Date(2000, monthMap[monthA], dayA);
      const dateB = new Date(2000, monthMap[monthB], dayB);

      return dateA - dateB;
    });

    return dates.join(", ");
  }

  function getAllTimesString(eventTimes) {
    let times = [];
    eventTimes.map((eventTime) => {
      const startTime = eventTime?.start_time;
      if (startTime && startTime.length > 0) {
        const [hour, minute] = startTime?.split(":") || [];
        const hourIn12HourFormat = hour % 12 || 12;
        const period = hour < 12 ? "AM" : "PM";
        const timeIn12HourFormat = `${hourIn12HourFormat}:${minute} ${period}`;
        if (!times.includes(timeIn12HourFormat)) {
          times.push(timeIn12HourFormat);
        }
      }
    });
    times.sort();
    return times.join(", ");
  }

  const dates = getAllDatesString(eventTimes);
  const times = getAllTimesString(eventTimes);
  const showTimes =
    Boolean(times) &&
    !hideTimesOnCard &&
    selectedDay?.slug != "all-days";

  return (
    <div className="space-y-1">
      <div className="flex space-x-2">
        {(dates || everyDay) && (
          <Icon icon="events" size={20} strokeWidth={1.7} />
        )}
        {everyDay && <p>All Days</p>}
        {!everyDay && <p>{dates}</p>}
      </div>
      {showTimes && (
        <div className="flex space-x-2">
          <div>
            <Icon icon="clock" size={20} />
          </div>
          <p>{times}</p>
        </div>
      )}
    </div>
  );
}
